export default __webpack_public_path__ + "static/service-c156f244922854ad1bc1b96ff1b7311a.png";